import { Constants } from 'src/app/warr/common/constants';
import { Component } from '@angular/core';
import { ClickOutsideDirective } from 'src/app/directive/click-out-side.directive';
import { NotificationUserService } from './notification-user.service';
import { NotificationUser } from './notification-user';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'app-notification-user',
    templateUrl: './notification-user.component.html',
    styleUrls: ['./notification-user.component.scss'],
})
export class NotificationUserComponent { 
    isShowPopup: boolean = false;
    notificationData: NotificationUser.NotificationListResourceDTO = {
        totalNotRead: 0,
        items: []
    };
    isUpdateReadAll: boolean = false;
    constructor( 
        private notificationUserService: NotificationUserService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private oAuthService: OAuthService
        
    ) { 
    }

    get hasLoggedIn(): boolean {
        //return this.oAuthService.hasValidAccessToken();
        return false;
    }

    async ngOnInit() {
        await this.getNotificationList();
    }

    async openNotificationPopup(event: MouseEvent) {
         event.stopPropagation();
        this.isShowPopup = !this.isShowPopup;
        if(!this.isUpdateReadAll){
            this.isUpdateReadAll = true;
             await this.notificationUserService.updateReadAllNotification();
        }
        if(!this.isShowPopup){
           this.closePopup();
        }
    }

    closePopup(){
        this.notificationData.totalNotRead = 0;
        this.notificationData.items.forEach((item) => {
            item.isRead = true;
        });
        this.isShowPopup = false;
        this.cdr.detectChanges();
    }

    async getNotificationList(){
        const input = {
            appName: 'CP_WARR',
            skipCount: 0,
            maxResultCount: 20
        } as NotificationUser.NotificationFilterDto;
        const result = await this.notificationUserService.getNotificationByUser(input);
        if(result){
            this.notificationData = result;
            this.notificationData.totalNotRead = result.totalNotRead;
            this.cdr.detectChanges();
        }
    }

  onNotificationClick(notification: NotificationUser.Notification) {
    if(notification.referenceType === Constants.NotificationTypeEnum.AccessoryRequest){
        this.router.navigate([Constants.PageUrl.AccessoryRequestViewDetail, { id: notification.referenceId }]);
        this.closePopup();
    }
    if(notification.referenceType === Constants.NotificationTypeEnum.Warranty){
        this.router.navigate([Constants.PageUrl.WarrantyDetail, { id: notification.referenceId }]);
        this.closePopup();
    }
  }
}
